import { render } from "./GroupListForMessages.vue?vue&type=template&id=07048558&scoped=true"
import script from "./GroupListForMessages.vue?vue&type=script&lang=js"
export * from "./GroupListForMessages.vue?vue&type=script&lang=js"

import "./GroupListForMessages.vue?vue&type=style&index=0&id=07048558&lang=scss"
import "./GroupListForMessages.vue?vue&type=style&index=1&id=07048558&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07048558"]])

export default __exports__